import { ExportMode } from "@/ExportableFile/Models/enum/ExportMode";

class ExportableFileSignatureSettings {
    public ActionType: ExportMode;
    public ShouldSign: boolean;

    public constructor(init?: Partial<ExportableFileSignatureSettings>) {
        Object.assign(this, init);
    }
}

export { ExportableFileSignatureSettings };
